import * as Yup from "yup";
import { FormGroup } from "../../../components/form/models/models";

export const kinderProgramForm: FormGroup = {
  type: "formGroup",
  fields: [
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "sectionHeader",
      },
      label: "Kindergarten Program",
    },
    {
      type: "field",
      key: "teacherGivenName",
      fieldType: "input",
      label: "Teacher Given Name",
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      key: "teacherFamilyName",
      fieldType: "input",
      label: "Teacher Family Name",
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      key: "groupName",
      fieldType: "input",
      label: "Name of the Group the child will attend",
      validation: Yup.string().trim().required("A response is required"),
    },
    {
      type: "field",
      fieldType: "number",
      key: "kinderYear",
      label: "Kindergarten Year",
      props: {
        useGrouping: false,
        maxLength: 4,
      },
      validation: Yup.number()
        .required("A response is required")
        .test("is-invalid", "Please enter a valid year (YYYY)", (value) => {
          if (value < 1000) {
            return false;
          }
          return true;
        })
        .test("is-past", "Year may not be in the past", (value) => {
          if (value < new Date().getFullYear()) {
            return false;
          }
          return true;
        })
        .max(new Date().getFullYear() + 1, "Year may not be more than one (1) year in the future"),
    },
    {
      type: "field",
      key: "advisory",
      fieldType: "advisory",
      props: {
        type: "fieldadv",
      },
      label: "Enter the kindergarten year for which KIS is being applied",
    },
    {
      type: "field",
      key: "kinderYearLevel",
      fieldType: "dropdown",
      label: "Kindergarten Year that the child will be accessing",
      props: {
        options: [
          {
            label: "Three-year-old kindergarten",
            value: 1,
          },
          {
            label: "Four-year-old kindergarten",
            value: 2,
          },
          {
            label: "Second year 4-year-old kindergarten",
            value: 3,
          },
          {
            label: "Early Start kindergarten",
            value: 4,
          },
          {
            label: "Not provided",
            value: 5,
          },
        ],
      },
      validation: Yup.string().trim().required("A response is required"), // Basic required validation
    },
  ],
};
